export class DistributionMode {
    ID: number;
    Name: string;
    FullName: string;
}

export default DistributionMode;